"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronLeft } from "lucide-react";
import { useMenusContext } from "@core/helpers/client/contexts/MenusContext";
import useAnchorClick from "@/helpers/anchorScroll";
import useBodyScrollLock from "@core/helpers/client/hooks/useBodyScrollLock";

export const SELLER_ACADEMY_MENU_KEY = "header-main-menu-seller-academy";

const NavSellerAcademy = ({ mobileOpen, setMobileOpen } = {}) => {
    const { menus } = useMenusContext();
    const pathname = usePathname() || "";

    const items = menus?.[SELLER_ACADEMY_MENU_KEY] || [];

    useBodyScrollLock(mobileOpen);

    const closeDrawer = () => setMobileOpen?.(false);
    const is_current = (url) => Boolean(url) && !url.includes("#") && pathname === url;

    const handle_click = useAnchorClick(closeDrawer);

    if (!items?.length) return null;

    return (
        <>
            {/* desktop */}
            <nav className="hidden lg:flex items-center justify-center gap-6">
                {items.map((item) => (
                    <Link
                        key={item?.id}
                        href={item?.link?.url || ""}
                        onClick={handle_click(item?.link?.url)}
                        aria-current={is_current(item?.link?.url) ? "page" : undefined}
                        className="flex items-center gap-1 py-4 text-jmt-main whitespace-nowrap transition hover:text-jmt-primary-800 aria-[current=page]:text-jmt-primary-800">
                        {item?.title}
                    </Link>
                ))}
            </nav>

            {/* دراور موبایل فقط وقتی رندر می‌شود که هدر یک دکمه‌ی همبرگری برای بازکردنش
                بدهد. هدر سلر آکادمی مطابق فیگما در موبایل منو ندارد، پس آنجا رندر نمی‌شود. */}
            {setMobileOpen && <div
                style={{
                    top: "var(--header-height, 64px)",
                    height: "calc(100dvh - var(--header-height, 64px))",
                }}
                className={`lg:hidden fixed inset-x-0 z-30 transition-opacity duration-300 ease-in-out ${mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
                    }`}>

                <div onClick={closeDrawer} className="absolute inset-0 bg-black/40" />

                <div className={`relative w-full h-full bg-jmt-white overflow-y-auto transition-transform duration-300 ease-in-out ${mobileOpen ? "translate-y-0" : "-translate-y-4"}`}>
                    <ul className="flex flex-col">
                        {items.map((item, index) => (
                            <li key={item?.id} className="px-4">
                                <div className={index === items.length - 1 ? "" : "border-b border-jmt-neutral-200"}>
                                    <Link
                                        href={item?.link?.url || ""}
                                        onClick={handle_click(item?.link?.url)}
                                        aria-current={is_current(item?.link?.url) ? "page" : undefined}
                                        className="w-full flex items-center justify-between py-4 text-sm text-jmt-main aria-[current=page]:text-jmt-primary-800">
                                        <span>{item?.title}</span>
                                        <ChevronLeft size={20} />
                                    </Link>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <div className="w-full h-0.5 bg-jmt-neutral-200" />

                    <Link
                        href="/"
                        onClick={closeDrawer}
                        className="flex items-center justify-between p-4 text-sm text-jmt-primary-800">
                        <span> رفتن به فروشگاه ژومنت </span>
                        <ChevronLeft size={20} />
                    </Link>
                </div>
            </div>}
        </>
    );
};

export default NavSellerAcademy;
